var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureSocialProofFilled = function SvgFeatureSocialProofFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M9.561 2a2.683 2.683 0 0 0-2.683 2.683v3.902a4.634 4.634 0 0 0 9.268 0V4.683A2.683 2.683 0 0 0 13.463 2H9.561m5.122 6.585v-1.22H8.34v1.22a3.17 3.17 0 0 0 6.342 0M17.854 12.732a4.146 4.146 0 0 0-4.147 4.146c0 1.045.558 2.033 1.148 2.803.605.79 1.333 1.467 1.85 1.906l.012.01c.662.537 1.61.537 2.272 0l.012-.01c.517-.439 1.246-1.115 1.852-1.906.59-.77 1.147-1.758 1.147-2.803a4.146 4.146 0 0 0-4.146-4.146m.995 4.156a.985.985 0 1 1-1.971 0 .985.985 0 0 1 1.97 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M8.729 15.644a.732.732 0 0 0-.287-1.435l-.963.193a.818.818 0 0 0-.027.005l-2.51.502A3.659 3.659 0 0 0 2 18.497v1.796a.732.732 0 0 0 1.463 0v-1.796c0-1.047.74-1.948 1.765-2.153l1.65-.33v1.72a2.196 2.196 0 1 0 1.463 0v-2.012l.388-.078"
  })));
};
export default SvgFeatureSocialProofFilled;